export const removeFromArray = (array, item) => {
    const index = array.indexOf(item);
    if (index !== -1) {
        array.splice(index, 1);
    }
    return array;
}

export const notEmptyArray = (value) => value && Array.isArray(value) && value.length > 0;